import React from 'react'
import { AppStep } from '../types'
import { Check } from 'lucide-react'

interface Props {
  currentStep: AppStep
}

const steps: { key: AppStep; label: string }[] = [
  { key: 'consent', label: 'Data Privacy' },
  { key: 'upload', label: 'Upload & Details' },
  { key: 'review', label: 'Review' },
  { key: 'complete', label: 'Complete' }
]

export default function ProgressIndicator({ currentStep }: Props) {
  const currentIndex = steps.findIndex(s => s.key === currentStep)

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isCompleted = index < currentIndex
          const isCurrent = index === currentIndex

          return (
            <React.Fragment key={step.key}>
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium
                    ${isCompleted ? 'bg-emerald-600 text-white' : ''}
                    ${isCurrent ? 'bg-emerald-600 text-white ring-4 ring-emerald-100' : ''}
                    ${!isCompleted && !isCurrent ? 'bg-gray-200 text-gray-500' : ''}
                  `}
                >
                  {isCompleted ? <Check className="w-4 h-4" /> : index + 1}
                </div>
                <span
                  className={`
                    mt-2 text-xs font-medium
                    ${isCurrent ? 'text-emerald-700' : 'text-gray-500'}
                  `}
                >
                  {step.label}
                </span>
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`
                    flex-1 h-0.5 mx-2
                    ${index < currentIndex ? 'bg-emerald-600' : 'bg-gray-200'}
                  `}
                />
              )}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}
